import { Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex } from 'ui';
import { useDispatch } from 'react-redux';
import { toggleShowTravelTime } from '../containers/planning-board-actions';

const ViewFlex = styled(Flex)`
  margin-left: 7px;
  flex-flow: row nowrap;
  font-size: 13px;
  height: 34px;
  z-index: 2;
`;

const StyledSwitch = styled(Switch)`
  margin-top: 5px;
  background-color: ${p => p.checked ?
    p.theme.colors.theme :
    p.theme.colors.themeSecondary
  } !important;
`;
const TravelToggle = ({
  intl,
}) => {
  const [isSwitchedOn, setIsSwitchedOn] = useState(() => {
    const shouldShowTravelTime = JSON.parse(localStorage.getItem('should-show-travel-time'));
    return shouldShowTravelTime === null ? true : shouldShowTravelTime;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(toggleShowTravelTime(isSwitchedOn));
    localStorage.setItem('should-show-travel-time', JSON.stringify(isSwitchedOn));
  }, [isSwitchedOn]);

  const toggleSwitchHandler = () => {
    setIsSwitchedOn(prevState => !prevState);
  };

  return (
    <ViewFlex>
      <StyledSwitch
        checkedChildren={intl.formatMessage({
          id: 'planningBoard.showTravelTime.TITLE',
        })}
        unCheckedChildren={intl.formatMessage({
          id: 'planningBoard.showTravelTime.TITLE',
        })}
        checked={isSwitchedOn}
        onClick={toggleSwitchHandler}
      />
    </ViewFlex>
  );
};

TravelToggle.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default injectIntl(TravelToggle);
